import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { convertTimeZoneMinus } from '@app/shared/utils';
import { map, Observable } from 'rxjs';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import {
  AGENDAMENTO_STATUS,
  IAgendamento,
  IAgendamentoEvento,
  IAgendamentoMaterial,
  IAgendamentoSessao
} from '../model/agendamento.model';

@Injectable()
export class AgendamentoService extends EntityService<IAgendamento> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'agendamento'
    });
  }

  /**
   * Responsável por gerar o PDF do plano terapeutico
   * @returns
   */
  gerarPlanoTerapeutico(agendamento_id: string): Observable<any> {
    var url = `${this.baseURL}/${agendamento_id}/plano_terapeutico`;
    var paramsHttp = new HttpParams();

    const today = convertTimeZoneMinus(new Date());
    paramsHttp = paramsHttp.set('data_solicitacao', today.toISOString());

    return this.http.get(url, {
      headers: this.getHeader(),
      responseType: 'blob',
      params: paramsHttp
    });
  }

  /**
   * Responsável por alterar o evento_status da avaliação
   */
  registraEvento(
    type: AGENDAMENTO_STATUS | string,
    id: string,
    observacao?: string,
    motivo_cancelamento_id?: string,
    materiais?: IAgendamentoMaterial[],
    sessao?: IAgendamentoSessao
  ): Observable<IAgendamentoEvento> {
    return this.http
      .put<{ evento: IAgendamentoEvento }>(
        `${this.baseURL}/${id}/reg_evento`,
        JSON.stringify({
          status: type,
          status_at: new Date(),
          observacao,
          motivo_cancelamento_id: motivo_cancelamento_id,
          materiais,
          ...sessao
        }),
        {
          headers: this.getHeader()
        }
      )
      .pipe(map(res => res.evento));
  }

  /**
   * Gera as respostas do formulário de avaliação
   */
  criarRespostaFormulario(agendamento_id: string, formulario_id: string) {
    const url = `${this.baseURL}/${agendamento_id}/responder`;
    return this.http.put(url, JSON.stringify({ formulario_id }), {
      headers: this.getHeader()
    });
  }
}
